<template>
  <div class="user-data">
    <div v-if="errorMessage === ''">
      <slot></slot>
    </div>
    <div v-if="errorMessage !== ''" class="alert alert-warning" role="alert">
      {{errorMessage}}
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'errorMessage'
  ]
}
</script>



// WEBPACK FOOTER //
// src/components/ProfileTabContent.vue